import React, {useEffect, useState} from "react";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import {FormControlLabel, Radio, RadioGroup, Typography} from "@material-ui/core";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../Utils/lib";
import {uid} from "react-uid";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {getParamsFromString} from "../../Utils";

const RadioGroupComponent = (props) => {
    const [radioButtons, setRadioButtons] = useState([]);
    const {component, setValue, screenName, doActions} = props;
    const {properties = {}, styles: sourceStyles, events} = component;
    const [onChangeAction, setOnChangeAction] = useState([])
    const styles = sourceStyles ? sourceStyles[0] : {};
    const globalValues = useSelector(state => state.jsonScreen.globalValues);
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(properties.label, userLanguage)
    const label = getParamsFromString(multiLanguageLabel, globalValues, screenName);
    const radioValue = getParamsFromString(`{${properties.path}}`, globalValues, screenName);
    const radioButtonsData = getParamsFromString(properties.itemsData, globalValues, screenName);
    useEffect(() => {
        const radioButtons = properties.items ? properties.items : radioButtonsData;
        if(radioButtons instanceof Array) {
            setRadioButtons(radioButtons)
        }
    }, [JSON.stringify(properties.items), JSON.stringify(radioButtonsData)])

    useEffect(() => {
        const actions = events ? events[0] ? events[0].actions : undefined : undefined;
        if (actions) {
            if (actions.length) {
                setOnChangeAction(actions)
                return;
            }
            setOnChangeAction(onChangeAction);
        }
    }, []);

    function onChange(e) {
        try {
            setValue(e.target.value, properties.path)
            if (onChangeAction) {
                doActions(onChangeAction, {currentField: {value: e.target.value}});
            }
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div style={styles}>
            <FormControl component="fieldset">
                <FormLabel component="legend">{label}</FormLabel>
                <RadioGroup
                    row={styles.orientation === 'horizontal'}
                    onChange={onChange}
                    value={radioValue}
                >
                    {radioButtons ? radioButtons.map(item => {
                        return (
                            <FormControlLabel
                                key={uid(item)}
                                value={item} control={<Radio size={styles.size}/>} label={<span style={{
                                fontSize: styles.fontSize,
                                fontWeight: styles.fontWeight,
                                fontStyle: styles.fontStyle,
                                textDecoration: styles.textDecoration,
                                color: styles.color,
                            }}>{item}</span>}
                                labelPlacement={styles.labelPlacement}

                            />
                        )
                    }) : (
                        <>
                            <Typography>Radio items is not defined</Typography>
                        </>
                    )}


                </RadioGroup>
            </FormControl>
        </div>

    )
}
export default JsonScreenHoc(RadioGroupComponent)